var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenBigBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9179 5.83638C12.795 4.7592 11.9401 3.90431 10.8629 3.78137L9.85428 4.78998C10.7582 5.21059 11.4887 5.94111 11.9093 6.84499L12.9179 5.83638ZM3.45783 11.1864L8.33935 6.3049C9.41654 6.42784 10.2714 7.28273 10.3944 8.35991L5.51284 13.2414C5.47797 13.2763 5.44185 13.3097 5.40458 13.3416C5.14366 13.5647 4.82615 13.7133 4.48568 13.77L2.61795 14.0813L2.92924 12.2136C2.99409 11.8245 3.17889 11.4654 3.45783 11.1864ZM9.74006 2.22759L7.21653 4.75111L2.11952 9.84812C1.56166 10.406 1.19204 11.1242 1.06234 11.9024L0.605849 14.6414C0.463517 15.4954 1.20389 16.2357 2.05788 16.0934L4.79683 15.6369C5.57504 15.5072 6.29327 15.1376 6.85114 14.5797L11.9481 9.48273L14.4717 6.9592C14.6984 6.7325 14.8257 6.42503 14.8257 6.10443C14.8257 3.76777 12.9315 1.87353 10.5948 1.87353C10.2742 1.87353 9.96676 2.00089 9.74006 2.22759ZM0.946324 17.6456C0.423683 17.6456 0 18.0693 0 18.5919C0 19.1145 0.423683 19.5382 0.946324 19.5382H14.1949C14.7175 19.5382 15.1412 19.1145 15.1412 18.5919C15.1412 18.0693 14.7175 17.6456 14.1949 17.6456H0.946324Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#DFE8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenBigBlue);
export default __webpack_public_path__ + "static/media/penBigBlue.c1298869d7cefa9ef3e51ea99fb0337c.svg";
export { ForwardRef as ReactComponent };